<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="3"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<h3 class="cg-h3">{{ 'am.confirm.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-xl">
  {{ 'am.confirm.subHeader' | translate }}
</p>

<div class="cg-margin-bottom-lg">
  <cigna-table-review-confirm
    [users]="selectedUsers$ | async"
    [userType]="selectedUserType$ | async"
    tableView="review"
  >
  </cigna-table-review-confirm>
</div>

<cigna-page-step-navigation
  [showPrevious]="true"
  [nextEnabled]="(impersonator$ | async) === false"
  nextButtonLabel="Submit"
  [showCancel]="true"
  [submitting]="submitting$ | async"
  (previous)="previousScreen()"
  (next)="nextScreen()"
>
</cigna-page-step-navigation>

<ng-container *ngIf="(submitting$ | async) === false && (submitError$ | async)">
  <div
    class="cg-error-msg cg-margin-bottom-md cg-margin-top-md"
    *ngIf="submitError$ | async as submitError"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <span
      *ngIf="
        submitError.status === 403 || submitError.status === 504;
        else defaultMsg
      "
      >{{ 'am.interstitial.maxTinError' | translate }}</span
    >
    <ng-template #defaultMsg
      ><span
        data-spa-service-error
        data-test="submitError"
        *ngIf="submitError.errMsg"
      >
        {{ submitError.errMsg }}
      </span></ng-template
    >
  </div>
</ng-container>
